export const TABLE_DATA = {
  columns: ["OpenStack ", "AWS / Azure / Google Cloud"],
  data: [
    {
      feature: "Ownership",
      "OpenStack ": " Open-source, community-driven",
      "AWS / Azure / Google Cloud": " Proprietary, vendor-controlled",
    },
    {
      feature: "Customization",
      "OpenStack ": " Highly customizable",
      "AWS / Azure / Google Cloud": " Limited customization due to vendor lock-in",
    },
    {
      feature: "Deployment",
      "OpenStack ": " Can be deployed on private, public, or hybrid clouds",
      "AWS / Azure / Google Cloud": " Offered as a managed service",
    },
    {
      feature: "Cost",
      "OpenStack ": " No licensing costs, but requires infrastructure management",
      "AWS / Azure / Google Cloud": " Subscription-based pricing",
    },
    {
      feature: "Scalability",
      "OpenStack ": " Scales based on hardware resources",
      "AWS / Azure / Google Cloud": " Auto-scaling based on cloud provider’s resources",
    },
    {
      feature: "Security Control",
      "OpenStack ": " Full control over security configurations",
      "AWS / Azure / Google Cloud": " Security managed by the cloud provider",
    },
  ],
};
